<template>
  <v-container>
    <v-row justify="center">
      <v-col md="4">
        <v-autocomplete item-text="name" item-value="value" v-model="selectedEntrance" label="Изберете вход" :items="autocompleteBuildingsEntrances">
          <template v-slot:selection="data">
            {{ data.item.name }}
          </template>
          <template v-slot:item="data">
            <template>
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.name"></v-list-item-title>
                  <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                </v-list-item-content>
              </template>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :top="true" :right="true" :vertical="true" color="success" :timeout="5000">
      Successfully deleted
      <v-btn dark text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
    <v-row justify="center">
      <v-dialog v-model="confirmDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Are you sure?</v-card-title>
          <v-card-text>Do you really want to delete these records? This process cannot be undone.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="cancel">Cancel</v-btn>
            <v-btn color="green darken-1" text @click="agree">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-card :elevation="3">
      <v-data-table
        :headers="headers"
        :items="floors"
        :items-per-page="itemsPerPage"
        :page.sync="currentPage"
        :loading="tableLoading"
        :sort-by.sync="sortBy"
        :sort-desc.sync="descending"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <div class="flex-grow-1"></div>
            <v-btn color="indigo" dark class="mb-1" to="/floors/create">
              Добави етаж
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.title="props">
          {{ props.item.translations.title }}
        </template>
        <template v-slot:item.actions="props">
          <v-icon @click.native="handleEditClick(props.item.id)" small class="mr-2">mdi-pencil</v-icon>
          <v-icon @click.native="handleDeleteClick(props.item.id)" small>mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      tableLoading: true,
      selectedEntrance: null,
      itemsPerPage: 10,
      currentPage: 1,
      snackbar: false,
      sortBy: 'createdAt',
      descending: true,
      deleteId: null,
      confirmDialog: false,
      headers: [
        { text: 'Заглавие', sortable: false, value: 'title', width: '15%' },
        { text: 'Дата на създаване', value: 'createdAt' },
        { text: 'Последно редактиране', value: 'updatedAt' },
        { text: 'Actions', value: 'actions', sortable: false, align: 'right' }
      ]
    }
  },
  created () {
    this.$store.dispatch('fetchBuildingsEntrances')
    this.$store.dispatch('fetchFloors').then(() => this.tableLoading = false)
  },
  computed: {
    buildingsEntrances () {
      return this.$store.state.building.buildingsEntrances
    },
    autocompleteBuildingsEntrances () {
      const buildingsEntrances = [...this.buildingsEntrances]

      let result = []
      for (let building of buildingsEntrances) {
        result.push({ header: building.translations.title })
        for (let entrance of building.entrances) {
          result.push({ name: entrance.translations.title, group: building.translations.title, value: entrance.id })
        }
        result.push({ divider: true })
      }

      result.pop();
      return result
    },
    floors () {
      return this.$store.state.floor.floors
    }
  },
  methods: {
    getBuildingTitle (id) {
      const building = this.$store.getters.getBuilding(id)
      return building.title || ''
    },
    handleEditClick (id) {
      this.$router.push({ name: 'floors-edit', params: { id } })
    },
    handleDeleteClick (id) {
      this.confirmDialog = true
      this.deleteId = id
    },
    cancel () {
      this.confirmDialog = false
      this.deleteId = null
    },
    agree () {
      this.confirmDialog = false
      this.$store.dispatch('removeFloor', this.deleteId)
        .then(res => {
          if (res.data.success) {
            this.snackbar = true
            this.$store.dispatch('fetchFloors')

            this.deleteId = null
          }
        })
      }
  }
}
</script>

<style lang="scss">
.buildings-autocomplete {
  width: 100%;
  max-width: 400px;
}
.v-select-list {
  .v-subheader {
    background: #eee;
  }
}
</style>